var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "jp-wrapper",
      class: { "jp-sidebar--fold": _vm.sidebarFold },
      attrs: { id: "app" },
    },
    [
      [
        _c("main-navbar", { ref: "navbar", on: { showRight: _vm.showRight } }),
        _c("main-sidebar"),
        _c(
          "div",
          { staticClass: "jp-content__wrapper" },
          [_c("main-content")],
          1
        ),
        _c("main-right", { ref: "mainRight" }),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }